import {getExternalLink, isExternal, isRegistrationWithCustomDates} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import {useSettings} from '../../../../hooks/settings'
import settingsParams from '../../../../settingsParams'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent, isSecondRegistrationButtonVisible} from '../../../selectors/event'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'
import {CustomDatesLabel} from '../custom-dates-label'
import {SecondaryRsvpButtonProps} from './interfaces'
import s from './secondary-rsvp-button.scss'

export const SecondaryRsvpButton = ({className, narrowerButton, onClick}: SecondaryRsvpButtonProps) => {
  const {t} = useTranslation()
  const settings = useSettings()

  const visible = useAppSelector(isSecondRegistrationButtonVisible)
  const event = useAppSelector(getEvent)
  const {formattedRegistrationEndDate: date} = useEventDateInformation(event.id)

  const rsvpButtonText = settings.getWithFallback(settingsParams.rsvpEventButtonText, settingsParams.rsvpButtonText)

  return visible ? (
    <div className={classNames(s.container, s.spacing, className)}>
      <RegistrationButtonSkin
        secondary
        dataHook={DH.RSVP_BUTTON}
        narrowerButton={narrowerButton}
        isExternalLink={isExternal(event)}
        text={rsvpButtonText}
        url={getExternalLink(event)}
        onClick={onClick}
      />
      {isRegistrationWithCustomDates(event) && (
        <CustomDatesLabel dataHook={DH.RSVP_CLOSES_LABEL} text={t('registration.closesLabel', {date})} />
      )}
    </div>
  ) : null
}
